import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import RefreshIcon from '@material-ui/icons/Refresh';
import { useTranslation } from 'react-i18next';

// All the incoming values
interface IProps {
    disabled?: boolean;
}

// Outgoing functions
interface IDispatch {
    onClick: () => void
}

// Actual Component
export type AllProps = IProps & IDispatch;
export const RefreshButton = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t } = useTranslation('common');
    return (<Button startIcon={<RefreshIcon />} disabled={props.disabled} onClick={e => {e.stopPropagation(); props.onClick && props.onClick()}} variant="contained" color="primary">{t('refresh')}</Button>)
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({ }));